import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import withLoader from 'components/Shared/withLoader';
import { ReclamationFiltre } from '../../../../../constants';
import { ReclamationFiltreNoms } from '../../../../../constants';
import { deepPurple } from '@mui/material/colors';

const styles = theme => ({
    card: {
        height: '100%'
    },
    content: {
        display: 'flex',
        alignItems: 'center'
    },
    divider: {
        paddingTop: 16,
        paddingBottom: 16
    },
    avatar: {
        flex: '0 0 auto',
        marginRight: 12,
        width: 60,
        height: 60,
        color: '#fff',
        backgroundColor: deepPurple[500]
    },
    title: {
        flex: '1 1 auto',
        marginLeft: 12
    },
    link: theme.style.link
});

const IndicateurWithLoader = withLoader(
    ({ count }) => (<Typography variant="h6" gutterBottom>{count}</Typography>)
);

const NbCommentairesIndicateur = ({ classes, count, isLoading, onClick }) => (
    <Card className={classes.card}>
        <CardContent>
            <Link to={"/reclamations#" + ReclamationFiltreNoms[ReclamationFiltre.Commentaires]} onClick={onClick} className={classes.link}>
                <div className={classes.content}>
                    <Avatar className={classes.avatar}>
                        <QuestionAnswerIcon />
                    </Avatar>
                    <div className={classes.title}>
                        <Typography variant="subtitle1" gutterBottom>Commentaires</Typography>
                        <IndicateurWithLoader isLoading={isLoading} count={count} />
                    </div>
                </div>
            </Link>
            <div className={classes.divider}>
                <Divider />
            </div>
            <Typography variant="caption">Nombre de commentaires en attente qui me sont affectés</Typography>
        </CardContent>
    </Card >
);

NbCommentairesIndicateur.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(NbCommentairesIndicateur);